export type CreateAccountValuesType = {
  first_name: string;
  last_name: string;
  dob: string;
  email: string;
  password: string;
  confirm_password?: string;
  middle_name?: string;
  gender?: "Male" | "Female";
  zip?: string;
  referral?: string;
};

export type SignupVerificationValues = Omit<
  CreateAccountValuesType,
  "dob" | "zip"
> & {
  // null is empty; Invalid Date preserves incomplete or malformed input.
  dob: Date | null;
  zip: string;
};

export const MIN_DATE_OF_BIRTH = new Date(1900, 0, 1);
